<template>
  <VueFinalModal
    :esc-to-close="true"
    class="flex justify-center items-center"
    content-class="relative flex flex-col w-[600px] mx-auto bg-white border rounded-lg"
  >
    <div ref="tmpl">
      <form action="#">
        <div class="p-6">
          <div class="pb-4 text-xl text-center">Issue Settings</div>
          <div class="grid grid-cols-3">
            <div
              id="dropdownDots"
              class="ml-10 border-2 z-10 bg-blue-600 text-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 dark:divide-gray-600"
            >
              <div class="py-2 pl-2 flex">
                Departments
                <i class="fa fa-plus-square-o text-white ml-auto pt-1 pr-4" @click="setEdit('departments')" >
                </i>
              </div>
              <ul class="py-2 text-sm bg-white text-black flex-col">
                <li
                  v-for="dept in config.departments"
                  :key="dept"
                  class="flex pl-4 py-2 border-t hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  :class="{ selected: isSelected(dept) }"
                  @click="setSelected(dept)"
                >
                  {{ titleize(dept)
                  }}<i
                    class="fa fa-pencil-square-o ml-auto pt-1 pr-2"
                    @click="setEdit('departments', dept)"
                  ></i>
                  <i class="fa fa-trash-o pt-1" @click="deleteDept(dept)"></i>
                </li>
              </ul>
            </div>
          </div>

          <div class="ml-5 mr-10 w-5/6 mt-5">
            <div
              id="dropdownDots"
              class="border-2 z-10 bg-blue-600 text-white rounded-lg shadow w-full"
            >
              <div class="py-2 pl-2 flex">
                Topics<i
                  class="fa fa-plus-square-o text-white ml-auto pt-1 pr-4"
                  @click="setEdit('topics')"
                ></i>
              </div>
              <ul class="py-2 text-sm bg-white text-black flex-col w-full">
                <li
                  v-for="topic in topicsForSelected"
                  :key="topic"
                  class="block px-4 py-2 border-t hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                >
                  <span class="flex"
                    >{{ titleize(topic)
                    }}<i class="fa fa-pencil-square-o ml-auto pt-1 pr-4"
                      @click="setEdit('topics', topic)"></i>
                      <i class="fa fa-trash-o pt-1" @click="deleteTopic(topic)"></i>
                    </span>
                </li>
              </ul>
            </div>
            <div class="flex-col pt-10 pl-10" v-show="editType">
              <div>{{ labelForEdit }}</div>
              <select
                v-model="deptValue"
                v-show="editType === 'topics' && editIndex != null"
                class="pt-2"
              >
                <option
                  v-for="dept in config.departments"
                  :key="dept"
                  :value="dept"
                >
                  {{ titleize(dept) }}
                </option>
              </select>
              <div class="flex-col py-2">
                <input type="text" ref="textInput" v-model="editValue" placeholder="new item name" />
                <span v-show ="editType=='topics'">
                  <input type="checkbox" id="duplicate-issue" class=" pl-2 mr-2" v-model="createDupe">Create Duplicate</input>
                </span>
                <div v-show="createDupe && editIndex != null" class="pt-2">
                  <select v-model="dupeDept" class="pt-2">
                    <option v-for="dept in config.departments.filter(d => d != selectedDepartment)" :key="dept" :value="dept">
                      {{ titleize(dept) }}
                    </option>
                  </select>
                </div>
              </div>
              <button @click.prevent="acceptEdit" class="p-2">
                <i class="p-2 fa fa-check-square-o bg-green-600 text-white"></i>
              </button>
              <button @click.prevent="clearEdit">
                <i class="p-2 fa fa-window-close-o bg-red-500 text-white"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="flex flex-row justify-end mt-4 p-6">
          <button
            class="btn btn-primary mr-2"
            @click="updateTopics()"
            :disabled="isEdit"
          >
            Update
          </button>
          <button class="btn btn-secondary" @click="closeModal()" :disabled="isEdit">
            Cancel
          </button>
        </div>
      </form>
    </div>
  </VueFinalModal>
</template>

<script setup>
  import { onMounted, ref, computed, nextTick } from 'vue'
  import { VueFinalModal } from 'vue-final-modal'
  import axios from "axios"
  import FlashMessages from '@services/FlashMessages'

  const props = defineProps({
    params: Object,
  })

  const emit = defineEmits(['close'])

  let config = ref({ departments: [], topics: [], duplicates: {} })
  let selectedDepartment = ref(null)
  let loaded = ref(false)
  let editType = ref(null)
  let editIndex = ref(null)
  let editValue = ref(null)
  let deptValue = ref(null)
  let createDupe = ref(null)
  let dupeDept = ref(null)

  onMounted(() => {
    config.value = window.gon.issue_config
    selectedDepartment.value = config.value.departments[0]
    loaded.value = true

    console.log("config", config.value)
  })

  const isEdit = computed(() => {
    return editType.value != null
  })

  const selectedDepartmentName = computed(() => {
    return titleize(selectedDepartment.value)
  })

  const topicsForSelected = computed(() => {
    return (
      selectedDepartment.value &&
      config.value.topics.filter((topic) =>
        topic.startsWith(selectedDepartment.value)
      )
    )
  })

  const labelForEdit = computed(() => {
    let editing = editType.value && titleize(editType.value.replace(/s$/, ""))
    let mode = editIndex.value != null ? "Update" : "Add new";
    let extra = editType.value == "topic" && editIndex.value != null ? "for " + selectedDepartmentName.value : ""
    
    return `${mode} ${editing} ${extra}`
  })


  function setEdit(type, item = null) {
    deptValue.value = selectedDepartment.value
    editType.value = type
    editIndex.value = item && config.value[type].indexOf(item)
    editValue.value = editIndex.value != null ? titleize(config.value[editType.value][editIndex.value]) : ""
    if (editType.value == 'topics' && item != null && config.value.duplicates[item]) {
      console.log(item)
      console.log(config.value.duplicates[item])
      createDupe.value = true
      dupeDept.value = config.value.duplicates[item]
    }
  }

  function acceptEdit() {
    let newValue = editType.value === "topics" ? `${deptValue.value}|${symbolize(editValue.value)}` : symbolize(editValue.value)

    switch (editType.value) {
      case "topics":
        if (editIndex.value === null) {
          config.value.topics.push(newValue);
        } else {
          config.value.topics[editIndex.value] = newValue;
        }

        if (dupeDept.value) {
          if (createDupe.value) {
            console.log('add duplicate')
            config.value.duplicates = (config.value.duplicates || {})
            config.value.duplicates[newValue] = dupeDept.value
          } else {
            delete config.value.duplicates[newValue]
          }
        }

        console.log(config.value)
        break;
      case "departments":
        if (editIndex.value === null) {
          config.value.departments.push(newValue);
        } else {
          updateDepartment(newValue)
        }
        break
    }
    console.log(config.value)
    // force a view update because reactivity on topics doesn't work reliably
    refreshTopics()
    // clear all edit fields
    clearEdit()
  }

  function updateDepartment(newValue) {
    let origDept = selectedDepartment.value

    config.value.topics.forEach(function (topic, index) {
      if (topic.startsWith(origDept + "|")) {
        config.value.topics[index] = topic.replace(origDept, newValue)
      }
    }, config.value.topics)

    config.value.departments[editIndex.value] = newValue
    selectedDepartment.value = newValue

    if (createDupe.value && dupeDept.value) {
      (config.value.duplicates || {})
    }
  }

  function clearEdit() {
    deptValue.value = editValue.value = editType.value = editIndex.value = createDupe.value = null
  }

  function setSelected(dept) {
    selectedDepartment.value = dept
  }

  function isSelected(dept) {
    return dept === selectedDepartment.value
  }

  function refreshTopics() {
    let dept = selectedDepartment.value
    selectedDepartment.value = null

    nextTick().then(() => {
      selectedDepartment.value = dept
    })
  }

  function deleteDept(dept) {
    if (confirm(`Are you sure you want to delete ${titleize(dept)} and all of it's topics`)) {
      let idx = config.value.departments.indexOf(dept)

      if (idx > -1) { // only splice array when item is found
        config.value.departments.splice(idx, 1)

        // Now let's delete all of this Departments Topics
        config.value.topics = config.value.topics.filter((topic) => !topic.startsWith(dept))
        console.log(selectedDepartment.value)
        console.log(dept)

        if (selectedDepartment.value == dept) {
          console.log('resetting department')
          setSelected(config.value.departments[0])
          console.log(selectedDepartment.value)
          refreshTopics()
        }
      }
    }
  }

  function deleteTopic(topic) {
    let idx = config.value.topics.indexOf(topic)
    if (idx > -1 && confirm(`Are you sure you want to delete ${titleize(topic)}?`)) { // only splice array when item is found
      config.value.topics.splice(idx, 1);
    }
  }

  function closeModal() {
    emit('close')
  }

  async function updateTopics() {
    try {
      await axios
        .post(
          `/issues/update_settings.json`,
          {
            settings: config.value,
          },
          {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              "X-CSRF-Token": document
                .querySelector('meta[name="csrf-token"]')
                .getAttribute("content"),
            },
          }
        )
        .then((response) => {
          console.log("The data", response)
          FlashMessages.success('Issue Settings were successfully updated')
          closeModal()
          window.location.reload()
        })
    } catch (err) {
      window.Rollbar.error("Failed to update Issue Settings", err )
      alert("Unable to update Issue Settings")
    } finally {
    }
  }

  function titleize(st) {
    if (st) {
      console.log(st)
      let lblPart = st.split('|').slice(-1)[0]
      console.log(lblPart)

      let words = lblPart.replaceAll('_',' ').split(' ')
      let newWords = words.map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1)
      })
      return newWords.join(' ')
    } else {
      return null
    }
  }

  function symbolize(st) {
    return st ? st.toLowerCase().replaceAll(' ', '_') : null
  }
</script>

<style>
.vm--modal {
  overflow: initial !important;
}

.bold {
  font-weight: bold;
}

.pad {
  margin: 5px;
}

.selected {
  @apply bg-blue-300 hover:bg-blue-200;
}
</style>
